export default __webpack_public_path__ + "static/media/clean-glass.08977e61.jpeg";